<nz-layout>
  <nz-sider
    nzWidth="262px"
    [nzCollapsed]="isCollapsed()"
  >
    <app-logo />
    <app-slider-menu />
  </nz-sider>
  <nz-layout>
    <nz-header>
      <app-header />
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet />
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
